import service from "@/utils/request";
import { ACTIVITY_BASE_URL } from "@/config/url";

// 螺蛳壳使用列表
export function getLotteryRecord(): Promise<any> {
  return service({
    baseURL: ACTIVITY_BASE_URL,
    url: "/lottery/getLotteryRecord",
    method: "GET",
  });
}
